import API from '../../../shared/api/API'
import { AxiosPromise } from 'axios'
import { SchoolModel } from './types'
import { Paginated, PaginatedParams } from '../../../shared/api/types'
import CollectionQueryHelper from '../../../shared/helpers/CollectionQueryHelper'
import { cleanObject } from '../../../shared/helpers/cleanObject'

type SchoolLoadResponse = Paginated<SchoolModel>

class SchoolApi {
  static load = ({ limit = 10, page = 0, sort, search }: PaginatedParams = {}): AxiosPromise<SchoolLoadResponse> =>
    API.get(`/statistics/school`, {
      params: cleanObject({
        $limit: limit,
        $skip: limit * page,
        $sort: sort && CollectionQueryHelper.sortParamsToQueryString(sort),
        $search: search?.toLocaleLowerCase()
      })
    })
}

export default SchoolApi
